import "./nav-menu.css";
import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useRootContext } from "../../hooks/useRootContext";
import ServiceCategories from "../service-categories/ServiceCategories";

function NavMenu() {
  const { isNavMenuOpen, setIsNavMenuOpen, navHeight, setIsRouteLoading } = useRootContext();

  const navigate = useNavigate();

  useEffect(() => {
    const preventScroll = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const disableScroll = () => {
      document.addEventListener("wheel", preventScroll, { passive: false });
      document.addEventListener("touchmove", preventScroll, { passive: false });
      window.addEventListener("scroll", preventScroll, { passive: false });
    };

    const enableScroll = () => {
      document.removeEventListener("wheel", preventScroll, { passive: false });
      document.removeEventListener("touchmove", preventScroll, {
        passive: false,
      });
      window.removeEventListener("scroll", preventScroll, { passive: false });
    };

    if (isNavMenuOpen) {
      disableScroll();
    } else {
      enableScroll();
    }

    return () => {
      enableScroll();
    };
  }, [isNavMenuOpen]);

  return (
    <div
      className={isNavMenuOpen ? "nav-menu opened" : "nav-menu closed"}
      style={
        window.innerWidth > 768
          ? { marginTop: `${navHeight}px` }
          : {
            marginTop: `${navHeight}px`,
            height: `calc(100vh - ${navHeight}px)`,
          }
      }
    >
      {window.innerWidth > 768 ? (
        <ServiceCategories
          isNavModalOpen={isNavMenuOpen}
          setIsNavModalOpen={setIsNavMenuOpen}
        />
      ) : (
        <>
          <div className="nav-menu-links">
            <NavLink
              className="nav-menu-link"
              to="/"
              onClick={() => {
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            >
              <span>Home</span>
              <div className="nav-menu-link-border"></div>
            </NavLink>
            <NavLink
              className="nav-menu-link"
              to="/services"
              onClick={() => {
                setIsNavMenuOpen(!isNavMenuOpen);
                setIsRouteLoading(true);
              }}
            >
              <span>Services</span>
              <div className="nav-menu-link-border"></div>
            </NavLink>
            <NavLink
              className="nav-menu-link"
              to="/our-work"
              onClick={() => {
                setIsNavMenuOpen(!isNavMenuOpen);
                setIsRouteLoading(true);
              }}
            >
              <span>Our Works</span>
              <div className="nav-menu-link-border"></div>
            </NavLink>
            <NavLink
              className="nav-menu-link"
              to="/about"
              onClick={() => {
                setIsNavMenuOpen(false);
                setIsRouteLoading(true);
              }}
            >
              <span>About Us</span>
              <div className="nav-menu-link-border"></div>
            </NavLink>
          </div>
          <button
            className="nav-menu-send-message-btn"
            onClick={() => {
              navigate("/contact-us");
              setIsNavMenuOpen(false);
              setIsRouteLoading(true);
            }}
          >
            Contact Us
          </button>

          <a
            className={`nav-menu-phone`}
            href="mailto:Hi@TiMN.GE"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={12} viewBox="0 0 20 12" fill="none">
              <g clipPath="url(#clip0_154_5874)">
                <path d="M20 2.27026C20 5.129 20 7.9881 20 10.8468C19.7891 11.4782 19.3426 11.8721 18.6328 12C12.8777 12 7.12227 12 1.36719 12C0.646875 11.8627 0.187109 11.4699 0 10.8108C0 7.96396 0 5.11711 0 2.27026C3.18945 3.90954 6.38008 5.54594 9.56523 7.19243C9.87344 7.35171 10.1254 7.35423 10.4355 7.19387C13.6199 5.5463 16.8109 3.9099 20 2.27026Z" fill="white" />
                <path d="M0 1.18919C0 1.1773 0 1.16505 0 1.15315C0.189453 0.54018 0.625 0.161441 1.28906 0C7.09648 0 12.9035 0 18.7109 0C19.3754 0.161081 19.8102 0.540541 20 1.15315C20 1.16505 20 1.1773 20 1.18919C19.9348 1.22847 19.8719 1.27135 19.8039 1.30631C16.6156 2.94595 13.4266 4.58342 10.241 6.22739C10.0652 6.3182 9.93477 6.3164 9.76016 6.22631C7.09727 4.85117 4.43008 3.4836 1.76562 2.11099C1.17539 1.80685 0.574219 1.52 0 1.18919Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_154_5874">
                  <rect width={20} height={12} fill="white" />
                </clipPath>
              </defs>
            </svg>
            &nbsp;&nbsp;&nbsp;Hi@TiMN.GE
          </a>
          <a
            className={`nav-menu-phone`}
            href="tel:+995599234077"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_154_5868)">
                <path d="M0 2.42521C0.327921 1.08483 1.37505 0.498505 2.51089 0.0272117C2.66931 -0.03829 2.94495 0.0256141 3.09545 0.132654C3.35208 0.313183 3.59921 0.544835 3.7703 0.810037C4.35485 1.71748 4.91881 2.6377 5.45901 3.57229C5.73465 4.04998 5.66178 4.53725 5.31327 4.97179C5.30535 4.98138 5.29901 4.99097 5.29267 5.00055C4.58931 5.93515 4.43089 6.24668 5.29109 7.44808C6.27644 8.82362 7.47564 9.99306 8.86653 10.95C9.64911 11.4884 10.0547 11.4948 10.785 10.8909C11.425 10.3605 12.0586 10.2982 12.7366 10.7296C13.6349 11.3015 14.5267 11.8846 15.3996 12.4949C15.642 12.6643 15.8051 12.9502 16.0032 13.1835C16.0032 13.2554 16.0032 13.3273 16.0032 13.3992C15.9034 13.5429 15.7988 13.6819 15.7069 13.8305C15.4646 14.2251 15.2554 14.6437 14.983 15.0143C14.4428 15.7524 13.703 16.1103 12.7921 15.9713C12.3422 15.9026 11.8891 15.7716 11.4725 15.5863C8.72396 14.3705 6.33663 12.6323 4.33426 10.3893C2.41743 8.24369 0.736634 5.93675 0 3.07065C0 2.85497 0 2.64089 0 2.42521Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_154_5868">
                  <rect width={16} height={16} fill="white" />
                </clipPath>
              </defs>
            </svg>
            &nbsp;&nbsp;&nbsp;+ 995 599 234 077
          </a>
        </>
      )}
    </div>
  );
}

export default NavMenu;
